import React from 'react'
import "../styles/Hero.css";
import Hero from '../components/Hero';
import Beneficios from '../components/Beneficios';
export default function Home() {
  return (
    <div>
      <Hero />
      <Beneficios />
    </div>
  );
}
